import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";

export const Toggle = styled.a<{ isOpen: boolean }>`
    display: block;
    position: relative;
    padding: 11px 30px 15px 18px;
    font-size: 1.5rem;
    text-decoration: none;
    color: ${theme.colors.primaryBlack};
    background: ${({ isOpen }) => (isOpen ? theme.colors.grey1 : "none")};
    border-radius: ${({ isOpen }) => (isOpen ? "4px 4px 0 0" : "4px")};
    outline: 0;
    cursor: pointer;

    svg {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
    }

    &:hover {
        text-decoration: none;
    }

    html[dir="rtl"] & {
        padding: 11px 18px 15px 30px;
        svg {
            left: 10px;
            right: auto;
        }
    }
`;

export const Title = styled.button.attrs(() => ({
    className: "t-base-headline mb-0",
}))<{ selected?: boolean; height?: number; showPointer: boolean; isPdf?: boolean }>`
    display: ${({ isPdf }) => (isPdf ? "inline-block" : "flex")};
    align-items: flex-start;
    justify-content: space-between;
    min-height: ${({ height, isPdf }) => (height && !isPdf ? height : 0)}px;
    padding-bottom: ${theme.space[1]}px;
    text-align: start;
    color: ${theme.colors.primaryBlack};
    cursor: ${({ showPointer }) => (showPointer ? "pointer" : "inherit")};
`;
